import { ProgramType, VendorEquipmentTypes } from 'types';

import { api } from './api';

const tag = 'ApprovedVendors';
export const approvedVendorsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApprovedVendorsByType: build.query<
      any,
      {
        programType?: ProgramType;
        equipmentType?: VendorEquipmentTypes;
        includeException?: boolean;
        orgAlias?: string;
        accountId?: string;
      }
    >({
      query: ({ programType, equipmentType, includeException, orgAlias, accountId }) => {
        const params = new URLSearchParams();
        if (programType) params.append('programType', programType);
        if (includeException) params.append('includeException', 'true');
        if (orgAlias) params.append('orgAlias', orgAlias);
        if (accountId) params.append('accountId', accountId);

        return { url: `approved-vendors/${equipmentType}?${params.toString()}` };
      },
      providesTags: (_result, _error, { programType, equipmentType }) => [
        { type: tag, programType, equipmentType: equipmentType ?? 'all' },
      ],
    }),
  }),
});

export const { useGetApprovedVendorsByTypeQuery } = approvedVendorsApi;
